// extracted by mini-css-extract-plugin
module.exports = {"root":"voicemessageform_root__EStNa","recordSoundwave":"voicemessageform_recordSoundwave__3yg9q","btnGroup":"voicemessageform_btnGroup__34Bcb","btn":"voicemessageform_btn__30xiY"};